import { createColumnHelper } from '@tanstack/react-table'
import { UserGroup } from '../../types/GroupTypes'

export const groupColumns = (navigateToGroup: (groupId: number) => void) => {
  const columnHelper = createColumnHelper<UserGroup>()

  const columnHelpers = [
    columnHelper.accessor('name', {
      header: 'Group Name',
    }),
    columnHelper.accessor('memberCount', {
      header: 'Members',
    }),
    columnHelper.accessor('policyCount', {
      header: 'Policies',
    }),
    {
      id: 'button',
      cell: (row: { row: { original: UserGroup } }) => (
        <div className="h-[26px] flex float-right">
          <button
            className="h-[26px] cursor-pointer border border-mainBorder text-textTertiary rounded px-3 font-medium mr-2"
            onClick={() => navigateToGroup(row.row.original.id)}
          >
            View
          </button>
        </div>
      ),
    },
  ]

  return columnHelpers
}
